import webApi, { baseURL } from "../../WebApi/WebApi";

//business unit LISTING
export const getAllBusinesslist = async (data, array) => {
  // console.log(data, array, "array");
  return await webApi.post(
    `/customer/business-unit/get-business-unit-list?searchKeyword=${data}`,
    {
      departmentList: array,
    }
  );
};

//ADD DEPARTMENT
export const getDepartment = async (
  departmentName,
  shortName,
  identificationNumber,
  accountKey,
  businessUnitNameId,
  address,
  myArrayUser,
  stock,
  onSuccess,
  onFailure
) => {
//  console.log(myArrayUser, "qqqqqq");
  try {
    const res = await webApi.post(`/customer/department/add-department`, {
      name: departmentName,
      shortName: shortName,
      buIdentificationNumber: identificationNumber,
      accountingKey: accountKey,
      businessUnitId: businessUnitNameId,
      address: address,
      userIds: myArrayUser,
      is_stock: stock,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
  //  console.log("fdgdf");
  }
};

//Department LISTING
export const getAllDepartmentDetailslist = async (data = "", department) => {
  return await webApi.post(
    `/customer/department/list-department?searchKeyword=${data}`,
    {
      departmentId: Number(department) ? Number(department) : "",
    }
  );
};

export const getAllMyDepartmentDetailslist = async () => {
  return await webApi.get(`/customer/department/list-my-department`);
};

//DEPARTMENT DETAILS BY ID
export const getDepartmentById = async (data) => {
//  console.log(data, "datata");
  return await webApi.post(`/customer/department/get-department-by-id`, {
    departmentId: Number(data),
  });
};

export const getIndustryById = async (data) => {
//  console.log(data, "datata");
  return await webApi.post(`/customer/business-unit/get-business-unit-by-id/`, {
    businessUnitId: data,
  });
};

//update Department

export const getUpdateDepartment = async (
  businessUnitName,
  shortName,
  identificationNumber,
  accountingKey,
  businessUnitId,
  address,
  id,
  userIds,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(`/customer/department/edit-department`, {
      name: businessUnitName,
      shortName: shortName,
      buIdentificationNumber: identificationNumber,
      accountingKey: accountingKey,
      businessUnitId: businessUnitId,
      address: address,
      departmentId: id,
      userIds: userIds,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
  //  console.log("fdgdf");
  }
};

export const getActiveDepartment = async (
  module,
  id,
  isactive,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(`/customer/common/is-active`, {
      module: module,
      id: id,
      isActive: isactive,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
  //  console.log("fdgdf");
  }
};

export const listDepartmentByBusinessId = async (id, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(
      `/customer/department/list-department-business-id`,
      { businessUnitId: id }
    );
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
  //  console.log(error);
  }
};
